<template>
  <div>
    <section class="page-content rx-page-application">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section table-wrapper">
              <label>
                <strong>
                  <span class="mr-1">10.</span>
                  Provide your gross revenues for the last 12 months and projected next 12 months. If newly established, please provide an
                  estimate of revenues for the current annual period (Gross revenues are defined as all fees and commissions before expenses,
                  including fees, commissions and bonuses payable to employees and independent contractors):
                </strong>
              </label>
              <p style="text-align: center;color: red">
                <strong>
                  YOU MUST PROVIDE REVENUE OR ESTIMATE OF REVENUE TO RECEIVE A QUOTE
                </strong>
              </p>
              <div class="table-scroll">
                <table class="w-100">
                  <thead>
                    <tr>
                      <th></th>
                      <th colspan="2">Last 12 Months</th>
                      <th colspan="2">Projected Next 12 Months</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>$ Gross Revenue</th>
                      <th># of Transactions / Appraisals</th>
                      <th>$ Projected Revenues</th>
                      <th># of Transactions / Appraisals</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th colspan="5">RESIDENTIAL</th>
                    </tr>
                    <tr>
                      <td>
                        Sales & Leasing
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueResidentialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueResidentialSales"
                        >
                        <span
                          v-show="errors.has('lastRevenueResidentialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueResidentialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberResidentialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberResidentialSales"
                        >
                        <span
                          v-show="errors.has('lastNumberResidentialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberResidentialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueResidentialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueResidentialSales"
                        >
                        <span
                          v-show="errors.has('nextRevenueResidentialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueResidentialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberResidentialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberResidentialSales"
                        >
                        <span
                          v-show="errors.has('nextNumberResidentialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberResidentialSales') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Agent/ Broker Owned Property Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueResidentialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueResidentialProperty"
                        >
                        <span
                          v-show="errors.has('lastRevenueResidentialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueResidentialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberResidentialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberResidentialProperty"
                        >
                        <span
                          v-show="errors.has('lastNumberResidentialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberResidentialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueResidentialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueResidentialProperty"
                        >
                        <span
                          v-show="errors.has('nextRevenueResidentialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueResidentialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberResidentialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberResidentialProperty"
                        >
                        <span
                          v-show="errors.has('nextNumberResidentialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberResidentialProperty') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Farm Land Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueResidentialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueResidentialFarm"
                        >
                        <span
                          v-show="errors.has('lastRevenueResidentialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueResidentialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberResidentialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberResidentialFarm"
                        >
                        <span
                          v-show="errors.has('lastNumberResidentialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberResidentialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueResidentialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueResidentialFarm"
                        >
                        <span
                          v-show="errors.has('nextRevenueResidentialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueResidentialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberResidentialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberResidentialFarm"
                        >
                        <span
                          v-show="errors.has('nextNumberResidentialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberResidentialFarm') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Raw Land Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueOwnedResidentialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueOwnedResidentialRaw"
                        >
                        <span
                          v-show="errors.has('lastRevenueOwnedResidentialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueOwnedResidentialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberOwnedResidentialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberOwnedResidentialRaw"
                        >
                        <span
                          v-show="errors.has('lastNumberOwnedResidentialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberOwnedResidentialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueOwnedResidentialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueOwnedResidentialRaw"
                        >
                        <span
                          v-show="errors.has('nextRevenueOwnedResidentialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueOwnedResidentialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberOwnedResidentialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberOwnedResidentialRaw"
                        >
                        <span
                          v-show="errors.has('nextNumberOwnedResidentialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberOwnedResidentialRaw') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Appraisals*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueOwnedResidentialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueOwnedResidentialAppraisals"
                        >
                        <span
                          v-show="errors.has('lastRevenueOwnedResidentialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueOwnedResidentialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberOwnedResidentialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberOwnedResidentialAppraisals"
                        >
                        <span
                          v-show="errors.has('lastNumberOwnedResidentialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberOwnedResidentialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueOwnedResidentialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueOwnedResidentialAppraisals"
                        >
                        <span
                          v-show="errors.has('nextRevenueOwnedResidentialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueOwnedResidentialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberOwnedResidentialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberOwnedResidentialAppraisals"
                        >
                        <span
                          v-show="errors.has('nextNumberOwnedResidentialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberOwnedResidentialAppraisals') | filterText }}</span>
                      </td>
                    </tr>

                    <tr>
                      <th colspan="5">COMMERCIAL</th>
                    </tr>
                    <tr>
                      <td>
                        Sales & Leasing
                      </td>
                      <td>
                        <input
                          type="number"
                          class="orep-text-input"
                          name="lastRevenueCommercialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueCommercialSales"
                        >
                        <span
                          v-show="errors.has('lastRevenueCommercialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueCommercialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberCommercialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberCommercialSales"
                        >
                        <span
                          v-show="errors.has('lastNumberCommercialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberCommercialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueCommercialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueCommercialSales"
                        >
                        <span
                          v-show="errors.has('nextRevenueCommercialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueCommercialSales') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberCommercialSales"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberCommercialSales"
                        >
                        <span
                          v-show="errors.has('nextNumberCommercialSales')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberCommercialSales') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Agent/ Broker Owned Property Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueCommercialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueCommercialProperty"
                        >
                        <span
                          v-show="errors.has('lastRevenueCommercialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueCommercialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberCommercialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberCommercialProperty"
                        >
                        <span
                          v-show="errors.has('lastNumberCommercialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberCommercialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueCommercialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueCommercialProperty"
                        >
                        <span
                          v-show="errors.has('nextRevenueCommercialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueCommercialProperty') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberCommercialProperty"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberCommercialProperty"
                        >
                        <span
                          v-show="errors.has('nextNumberCommercialProperty')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberCommercialProperty') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Farm Land Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueCommercialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueCommercialFarm"
                        >
                        <span
                          v-show="errors.has('lastRevenueCommercialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueCommercialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberCommercialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberCommercialFarm"
                        >
                        <span
                          v-show="errors.has('lastNumberCommercialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberCommercialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueCommercialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueCommercialFarm"
                        >
                        <span
                          v-show="errors.has('nextRevenueCommercialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueCommercialFarm') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberCommercialFarm"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberCommercialFarm"
                        >
                        <span
                          v-show="errors.has('nextNumberCommercialFarm')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberCommercialFarm') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Raw Land Sales
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueOwnedCommercialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueOwnedCommercialRaw"
                        >
                        <span
                          v-show="errors.has('lastRevenueOwnedCommercialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueOwnedCommercialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberOwnedCommercialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberOwnedCommercialRaw"
                        >
                        <span
                          v-show="errors.has('lastNumberOwnedCommercialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberOwnedCommercialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueOwnedCommercialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueOwnedCommercialRaw"
                        >
                        <span
                          v-show="errors.has('nextRevenueOwnedCommercialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueOwnedCommercialRaw') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberOwnedCommercialRaw"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberOwnedCommercialRaw"
                        >
                        <span
                          v-show="errors.has('nextNumberOwnedCommercialRaw')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberOwnedCommercialRaw') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Appraisals*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueOwnedCommercialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueOwnedCommercialAppraisals"
                        >
                        <span
                          v-show="errors.has('lastRevenueOwnedCommercialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueOwnedCommercialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberOwnedCommercialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberOwnedCommercialAppraisals"
                        >
                        <span
                          v-show="errors.has('lastNumberOwnedCommercialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberOwnedCommercialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueOwnedCommercialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueOwnedCommercialAppraisals"
                        >
                        <span
                          v-show="errors.has('nextRevenueOwnedCommercialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueOwnedCommercialAppraisals') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberOwnedCommercialAppraisals"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberOwnedCommercialAppraisals"
                        >
                        <span
                          v-show="errors.has('nextNumberOwnedCommercialAppraisals')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberOwnedCommercialAppraisals') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th colspan="5">Other Services</th>
                    </tr>
                    <tr>
                      <td>
                        Property Management*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenuePropertyManagement"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenuePropertyManagement"
                        >
                        <span
                          v-show="errors.has('lastRevenuePropertyManagement')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenuePropertyManagement') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberPropertyManagement"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberPropertyManagement"
                        >
                        <span
                          v-show="errors.has('lastNumberPropertyManagement')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberPropertyManagement') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenuePropertyManagement"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenuePropertyManagement"
                        >
                        <span
                          v-show="errors.has('nextRevenuePropertyManagement')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenuePropertyManagement') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberPropertyManagement"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberPropertyManagement"
                        >
                        <span
                          v-show="errors.has('nextNumberPropertyManagement')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberPropertyManagement') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Sale of Business Opportunities*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueSalesOfBusiness"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueSalesOfBusiness"
                        >
                        <span
                          v-show="errors.has('lastRevenueSalesOfBusiness')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueSalesOfBusiness') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberSalesOfBusiness"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberSalesOfBusiness"
                        >
                        <span
                          v-show="errors.has('lastNumberSalesOfBusiness')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberSalesOfBusiness') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueSalesOfBusiness"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueSalesOfBusiness"
                        >
                        <span
                          v-show="errors.has('nextRevenueSalesOfBusiness')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueSalesOfBusiness') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberSalesOfBusiness"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberSalesOfBusiness"
                        >
                        <span
                          v-show="errors.has('nextNumberSalesOfBusiness')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberSalesOfBusiness') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Mortgage Brokering*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueMortgageBrokering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueMortgageBrokering"
                        >
                        <span
                          v-show="errors.has('lastRevenueMortgageBrokering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueMortgageBrokering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberMortgageBrokering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberMortgageBrokering"
                        >
                        <span
                          v-show="errors.has('lastNumberMortgageBrokering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberMortgageBrokering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueMortgageBrokering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueMortgageBrokering"
                        >
                        <span
                          v-show="errors.has('nextRevenueMortgageBrokering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueMortgageBrokering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberMortgageBrokering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberMortgageBrokering"
                        >
                        <span
                          v-show="errors.has('nextNumberMortgageBrokering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberMortgageBrokering') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Auctioneering (Real Property)*
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueAuctioneering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueAuctioneering"
                        >
                        <span
                          v-show="errors.has('lastRevenueAuctioneering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueAuctioneering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberAuctioneering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberAuctioneering"
                        >
                        <span
                          v-show="errors.has('lastNumberAuctioneering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberAuctioneering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueAuctioneering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueAuctioneering"
                        >
                        <span
                          v-show="errors.has('nextRevenueAuctioneering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueAuctioneering') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberAuctioneering"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberAuctioneering"
                        >
                        <span
                          v-show="errors.has('nextNumberAuctioneering')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberAuctioneering') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Short term Escrow
                        (Funds distributed within 1 year)
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueShortTermEscrow"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueShortTermEscrow"
                        >
                        <span
                          v-show="errors.has('lastRevenueShortTermEscrow')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueShortTermEscrow') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberShortTermEscrow"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberShortTermEscrow"
                        >
                        <span
                          v-show="errors.has('lastNumberShortTermEscrow')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberShortTermEscrow') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueShortTermEscrow"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueShortTermEscrow"
                        >
                        <span
                          v-show="errors.has('nextRevenueShortTermEscrow')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueShortTermEscrow') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberShortTermEscrow"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberShortTermEscrow"
                        >
                        <span
                          v-show="errors.has('nextNumberShortTermEscrow')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberShortTermEscrow') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Real Estate Consulting
                        (Provide details below)
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueRealEstateConsulting"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueRealEstateConsulting"
                        >
                        <span
                          v-show="errors.has('lastRevenueRealEstateConsulting')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueRealEstateConsulting') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberRealEstateConsulting"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberRealEstateConsulting"
                        >
                        <span
                          v-show="errors.has('lastNumberRealEstateConsulting')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberRealEstateConsulting') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueRealEstateConsulting"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueRealEstateConsulting"
                        >
                        <span
                          v-show="errors.has('nextRevenueRealEstateConsulting')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueRealEstateConsulting') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberRealEstateConsulting"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberRealEstateConsulting"
                        >
                        <span
                          v-show="errors.has('nextNumberRealEstateConsulting')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberRealEstateConsulting') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Other
                        (Provide details below)
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastRevenueOther"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastRevenueOther"
                        >
                        <span
                          v-show="errors.has('lastRevenueOther')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastRevenueOther') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="lastNumberOther"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="lastNumberOther"
                        >
                        <span
                          v-show="errors.has('lastNumberOther')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('lastNumberOther') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextRevenueOther"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextRevenueOther"
                        >
                        <span
                          v-show="errors.has('nextRevenueOther')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextRevenueOther') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="orep-text-input"
                          name="nextNumberOther"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="nextNumberOther"
                        >
                        <span
                          v-show="errors.has('nextNumberOther')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nextNumberOther') | filterText }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
            </article>
            <article class="input-section form-section">
              <label for class="orep-label mb-0">
                Details of "Real Estate Consulting" and "Other" from above (if applicable):
              </label>
              <div>
                <input
                  type="text"
                  class="mt-1 mb-1 orep-text-input"
                  name="detailsOfRealEstate1"
                  v-model="standardApplication.detailsOfRealEstate1"
                >
              </div>
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="detailsOfRealEstate2"
                v-model="standardApplication.detailsOfRealEstate2"
              >
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="detailsOfRealEstate3"
                v-model="standardApplication.detailsOfRealEstate3"
              >
            </article>
            <article class="input-section form-section" v-if="(Number(lastRevenueOwnedResidentialAppraisals) > 0 || Number(lastNumberOwnedResidentialAppraisals) > 0) || (Number(lastRevenueOwnedCommercialAppraisals) > 0 || Number(lastNumberOwnedCommercialAppraisals) > 0)">

              <label for class="orep-label">
                Supplemental Appraiser Questions:
              </label>
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">A. </span>
                    Are written agreements between the Applicant and the bank or financial institution in place that outline the duties of the appraiser and the fees charged for such services?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionOne"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionOne"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionOne"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionOne"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('supplementalAppraiserQuestionOne')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('supplementalAppraiserQuestionOne') | filterText }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">B. </span>
                    Does the Applicant always use standard appraisal forms that comply with USPAP?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionTwo"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionTwo"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionTwo"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionTwo"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('supplementalAppraiserQuestionTwo')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('supplementalAppraiserQuestionTwo') | filterText }}</span>
                </div>
              </div>
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">C. </span>
                    Does the Applicant perform any Right-of-Way appraisals?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionThree"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionThree"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="supplementalAppraiserQuestionThree"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.supplementalAppraiserQuestionThree"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('supplementalAppraiserQuestionThree')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('supplementalAppraiserQuestionThree') | filterText }}</span>
                </div>
              </div>
              <div class="flex" v-if="standardApplication.supplementalAppraiserQuestionThree == true || standardApplication.supplementalAppraiserQuestionThree === 'true'">
                  <div class="col-md-9">
                    <label for class="orep-label text-danger">
                      If Yes, please provide the revenue and number of transactions for the past 12 months:
                    </label>
                  </div>
              </div>
              <div class="flex" style="margin-bottom: 10px" v-if="standardApplication.supplementalAppraiserQuestionThree == true || standardApplication.supplementalAppraiserQuestionThree === 'true'">
                <div class="col-md-9">
              <label for class="orep-label">
                Right-of-Way Appraisals Last 12 Months Revenue:
              </label>
              <input
                type="text"
                name="supplementalAppraiserQuestionThreeRevenue"
                v-model="standardApplication.supplementalAppraiserQuestionThreeRevenue"
                class="orep-text-input"
                v-validate="'required'"
                @input="validateBeforeSubmit()">
                  <span
                    v-show="errors.has('supplementalAppraiserQuestionThreeRevenue')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('supplementalAppraiserQuestionThreeRevenue') | filterText }}</span>
                </div>
              </div>
              <div class="flex" v-if="standardApplication.supplementalAppraiserQuestionThree == true || standardApplication.supplementalAppraiserQuestionThree === 'true'">
                <div class="col-md-9">
                  <label for class="orep-label">
                  Number of Transactions:
                </label>
                <input
                  type="text"
                  name="supplementalAppraiserQuestionThreeTransactions"
                  v-model="standardApplication.supplementalAppraiserQuestionThreeTransactions"
                  class="orep-text-input"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                  <span
                    v-show="errors.has('supplementalAppraiserQuestionThreeTransactions')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('supplementalAppraiserQuestionThreeTransactions') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">11.</span>
                    Does the applicant have documented procedures which include instructions on how to handle complaints
                    and compliance with Federal, State and Local statutes?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantHaveDocumentedProcedures"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantHaveDocumentedProcedures"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantHaveDocumentedProcedures"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantHaveDocumentedProcedures"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantHaveDocumentedProcedures')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantHaveDocumentedProcedures') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">12 A.</span>
                    Does the applicant use approved board of REALTORS® or state association of REALTORS® standard
                    contract forms for the listing and sale of all Real Estate?
                  </label>
                </div>
                <div v-if="!state.standardApplication.realEstateAgentBroker" class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantUseApprovedBoardOfRealtors"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantUseApprovedBoardOfRealtors"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantUseApprovedBoardOfRealtors"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.doesApplicantUseApprovedBoardOfRealtors"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantUseApprovedBoardOfRealtors')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantUseApprovedBoardOfRealtors') | filterText }}</span>
                </div>
              </div>
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label" style="text-align: right;">
                    I am not a real estate agent/broker.
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="checkbox"
                          name="realEstateAgentBroker"
                          v-model="state.standardApplication.realEstateAgentBroker"
                          class="orep-radio"
                          @change="validateBeforeSubmitCheck($event)"
                        >
                        <span class="radio-span">N/A</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">12 B.</span>
                    In the last 5 years, have you appraised or transacted any commercial Office Buildings valued at over $3 million?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAnyCommercialOffice"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="standardApplication.haveAnyCommercialOffice"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAnyCommercialOffice"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="standardApplication.haveAnyCommercialOffice"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveAnyCommercialOffice')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveAnyCommercialOffice') | filterText }}</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'standard-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('standard-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('standard-application-4')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-5')">
            </button>
            <button
              class="pagination-dots"
              @click="navigateToNext('standard-application-6')"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-7')"
                :disabled="!state.pageSixIsValid">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-8')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid || !state.pageSevenIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('standard-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "standard-application-2",
  computed: {
    standardApplication() {
      return this.$store.state.standardApplication.standardApplication;
    },
    state() {
      return this.$store.state.standardApplication;
    },
    errorMsg() {
      return this.$store.state.standardApplication.errorMsg;
    },

    lastRevenueResidentialSales: {
      get: function() {
        return this.standardApplication.lastRevenueResidentialSales || '';
      },
      set: function(val) {
        if (val === ''){
          this.standardApplication.lastRevenueResidentialSales = 0;
        }
        else {

          this.standardApplication.lastRevenueResidentialSales = val;
        }
      }
    },

    lastNumberResidentialSales: {
      get: function () {
        return this.standardApplication.lastNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberResidentialSales = 0;
        } else {

          this.standardApplication.lastNumberResidentialSales = val;
        }
      },
    },

    nextRevenueResidentialSales: {
      get: function () {
        return this.standardApplication.nextRevenueResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueResidentialSales = 0;
        } else {

          this.standardApplication.nextRevenueResidentialSales = val;
        }
      },
    },

    nextNumberResidentialSales: {
      get: function () {
        return this.standardApplication.nextNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberResidentialSales = 0;
        } else {

          this.standardApplication.nextNumberResidentialSales = val;
        }
      },
    },


    lastRevenueResidentialProperty: {
      get: function () {
        return this.standardApplication.lastRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueResidentialProperty = 0;
        } else {

          this.standardApplication.lastRevenueResidentialProperty = val;
        }
      },
    },

    lastNumberResidentialProperty: {
      get: function () {
        return this.standardApplication.lastNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberResidentialProperty = 0;
        } else {

          this.standardApplication.lastNumberResidentialProperty = val;
        }
      },
    },

    nextRevenueResidentialProperty: {
      get: function () {
        return this.standardApplication.nextRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueResidentialProperty = 0;
        } else {

          this.standardApplication.nextRevenueResidentialProperty = val;
        }
      },
    },

    nextNumberResidentialProperty: {
      get: function () {
        return this.standardApplication.nextNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberResidentialProperty = 0;
        } else {

          this.standardApplication.nextNumberResidentialProperty = val;
        }
      },
    },


    lastRevenueResidentialFarm: {
      get: function () {
        return this.standardApplication.lastRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueResidentialFarm = 0;
        } else {

          this.standardApplication.lastRevenueResidentialFarm = val;
        }
      },
    },

    lastNumberResidentialFarm: {
      get: function () {
        return this.standardApplication.lastNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberResidentialFarm = 0;
        } else {

          this.standardApplication.lastNumberResidentialFarm = val;
        }
      },
    },

    nextRevenueResidentialFarm: {
      get: function () {
        return this.standardApplication.nextRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueResidentialFarm = 0;
        } else {

          this.standardApplication.nextRevenueResidentialFarm = val;
        }
      },
    },

    nextNumberResidentialFarm: {
      get: function () {
        return this.standardApplication.nextNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberResidentialFarm = 0;
        } else {

          this.standardApplication.nextNumberResidentialFarm = val;
        }
      },
    },


    lastRevenueOwnedResidentialRaw: {
      get: function () {
        return this.standardApplication.lastRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueOwnedResidentialRaw = 0;
        } else {

          this.standardApplication.lastRevenueOwnedResidentialRaw = val;
        }
      },
    },

    lastNumberOwnedResidentialRaw: {
      get: function () {
        return this.standardApplication.lastNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberOwnedResidentialRaw = 0;
        } else {

          this.standardApplication.lastNumberOwnedResidentialRaw = val;
        }
      },
    },

    nextRevenueOwnedResidentialRaw: {
      get: function () {
        return this.standardApplication.nextRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueOwnedResidentialRaw = 0;
        } else {

          this.standardApplication.nextRevenueOwnedResidentialRaw = val;
        }
      },
    },

    nextNumberOwnedResidentialRaw: {
      get: function () {
        return this.standardApplication.nextNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberOwnedResidentialRaw = 0;
        } else {

          this.standardApplication.nextNumberOwnedResidentialRaw = val;
        }
      },
    },


    lastRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.standardApplication.lastRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.standardApplication.lastRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    lastNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.standardApplication.lastNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberOwnedResidentialAppraisals = 0;
        } else {

          this.standardApplication.lastNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.standardApplication.nextRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.standardApplication.nextRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    nextNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.standardApplication.nextNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberOwnedResidentialAppraisals = 0;
        } else {

          this.standardApplication.nextNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    lastRevenueCommercialSales: {
      get: function () {
        return this.standardApplication.lastRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueCommercialSales = 0;
        } else {

          this.standardApplication.lastRevenueCommercialSales = val;
        }
      },
    },

    lastNumberCommercialSales: {
      get: function () {
        return this.standardApplication.lastNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberCommercialSales = 0;
        } else {

          this.standardApplication.lastNumberCommercialSales = val;
        }
      },
    },

    nextRevenueCommercialSales: {
      get: function () {
        return this.standardApplication.nextRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueCommercialSales = 0;
        } else {

          this.standardApplication.nextRevenueCommercialSales = val;
        }
      },
    },

    nextNumberCommercialSales: {
      get: function () {
        return this.standardApplication.nextNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberCommercialSales = 0;
        } else {

          this.standardApplication.nextNumberCommercialSales = val;
        }
      },
    },

    lastRevenueCommercialProperty: {
      get: function () {
        return this.standardApplication.lastRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueCommercialProperty = 0;
        } else {

          this.standardApplication.lastRevenueCommercialProperty = val;
        }
      },
    },

    lastNumberCommercialProperty: {
      get: function () {
        return this.standardApplication.lastNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberCommercialProperty = 0;
        } else {

          this.standardApplication.lastNumberCommercialProperty = val;
        }
      },
    },

    nextRevenueCommercialProperty: {
      get: function () {
        return this.standardApplication.nextRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueCommercialProperty = 0;
        } else {

          this.standardApplication.nextRevenueCommercialProperty = val;
        }
      },
    },

    nextNumberCommercialProperty: {
      get: function () {
        return this.standardApplication.nextNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberCommercialProperty = 0;
        } else {

          this.standardApplication.nextNumberCommercialProperty = val;
        }
      },
    },

    lastRevenueCommercialFarm: {
      get: function () {
        return this.standardApplication.lastRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueCommercialFarm = 0;
        } else {

          this.standardApplication.lastRevenueCommercialFarm = val;
        }
      },
    },

    lastNumberCommercialFarm: {
      get: function () {
        return this.standardApplication.lastNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberCommercialFarm = 0;
        } else {

          this.standardApplication.lastNumberCommercialFarm = val;
        }
      },
    },

    nextRevenueCommercialFarm: {
      get: function () {
        return this.standardApplication.nextRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueCommercialFarm = 0;
        } else {

          this.standardApplication.nextRevenueCommercialFarm = val;
        }
      },
    },

    nextNumberCommercialFarm: {
      get: function () {
        return this.standardApplication.nextNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberCommercialFarm = 0;
        } else {

          this.standardApplication.nextNumberCommercialFarm = val;
        }
      },
    },

    lastRevenueOwnedCommercialRaw: {
      get: function () {
        return this.standardApplication.lastRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueOwnedCommercialRaw = 0;
        } else {

          this.standardApplication.lastRevenueOwnedCommercialRaw = val;
        }
      },
    },

    lastNumberOwnedCommercialRaw: {
      get: function () {
        return this.standardApplication.lastNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberOwnedCommercialRaw = 0;
        } else {

          this.standardApplication.lastNumberOwnedCommercialRaw = val;
        }
      },
    },

    nextRevenueOwnedCommercialRaw: {
      get: function () {
        return this.standardApplication.nextRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueOwnedCommercialRaw = 0;
        } else {

          this.standardApplication.nextRevenueOwnedCommercialRaw = val;
        }
      },
    },

    nextNumberOwnedCommercialRaw: {
      get: function () {
        return this.standardApplication.nextNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberOwnedCommercialRaw = 0;
        } else {

          this.standardApplication.nextNumberOwnedCommercialRaw = val;
        }
      },
    },



    lastRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.standardApplication.lastRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.standardApplication.lastRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    lastNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.standardApplication.lastNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberOwnedCommercialAppraisals = 0;
        } else {

          this.standardApplication.lastNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.standardApplication.nextRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.standardApplication.nextRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    nextNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.standardApplication.nextNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberOwnedCommercialAppraisals = 0;
        } else {

          this.standardApplication.nextNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    lastRevenuePropertyManagement: {
      get: function () {
        return this.standardApplication.lastRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenuePropertyManagement = 0;
        } else {

          this.standardApplication.lastRevenuePropertyManagement = val;
        }
      },
    },
    lastRevenueSalesOfBusiness: {
      get: function () {
        return this.standardApplication.lastRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueSalesOfBusiness = 0;
        } else {

          this.standardApplication.lastRevenueSalesOfBusiness = val;
        }
      },
    },
    lastRevenueMortgageBrokering: {
      get: function () {
        return this.standardApplication.lastRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueMortgageBrokering = 0;
        } else {

          this.standardApplication.lastRevenueMortgageBrokering = val;
        }
      },
    },
    lastRevenueRealEstateConsulting: {
      get: function () {
        return this.standardApplication.lastRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueRealEstateConsulting = 0;
        } else {

          this.standardApplication.lastRevenueRealEstateConsulting = val;
        }
      },
    },
    lastRevenueOther: {
      get: function () {
        return this.standardApplication.lastRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueOther = 0;
        } else {

          this.standardApplication.lastRevenueOther = val;
        }
      },
    },
    lastNumberPropertyManagement: {
      get: function () {
        return this.standardApplication.lastNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberPropertyManagement = 0;
        } else {

          this.standardApplication.lastNumberPropertyManagement = val;
        }
      },
    },
    lastNumberSalesOfBusiness: {
      get: function () {
        return this.standardApplication.lastNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberSalesOfBusiness = 0;
        } else {

          this.standardApplication.lastNumberSalesOfBusiness = val;
        }
      },
    },
    lastNumberMortgageBrokering: {
      get: function () {
        return this.standardApplication.lastNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberMortgageBrokering = 0;
        } else {

          this.standardApplication.lastNumberMortgageBrokering = val;
        }
      },
    },
    lastNumberRealEstateConsulting: {
      get: function () {
        return this.standardApplication.lastNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberRealEstateConsulting = 0;
        } else {

          this.standardApplication.lastNumberRealEstateConsulting = val;
        }
      },
    },
    lastNumberOther: {
      get: function () {
        return this.standardApplication.lastNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberOther = 0;
        } else {

          this.standardApplication.lastNumberOther = val;
        }
      },
    },
    nextRevenuePropertyManagement: {
      get: function () {
        return this.standardApplication.nextRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenuePropertyManagement = 0;
        } else {

          this.standardApplication.nextRevenuePropertyManagement = val;
        }
      },
    },
    nextRevenueSalesOfBusiness: {
      get: function () {
        return this.standardApplication.nextRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueSalesOfBusiness = 0;
        } else {

          this.standardApplication.nextRevenueSalesOfBusiness = val;
        }
      },
    },
    nextRevenueMortgageBrokering: {
      get: function () {
        return this.standardApplication.nextRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueMortgageBrokering = 0;
        } else {

          this.standardApplication.nextRevenueMortgageBrokering = val;
        }
      },
    },
    nextRevenueRealEstateConsulting: {
      get: function () {
        return this.standardApplication.nextRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueRealEstateConsulting = 0;
        } else {

          this.standardApplication.nextRevenueRealEstateConsulting = val;
        }
      },
    },
    nextRevenueOther: {
      get: function () {
        return this.standardApplication.nextRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueOther = 0;
        } else {

          this.standardApplication.nextRevenueOther = val;
        }
      },
    },
    nextNumberPropertyManagement: {
      get: function () {
        return this.standardApplication.nextNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberPropertyManagement = 0;
        } else {

          this.standardApplication.nextNumberPropertyManagement = val;
        }
      },
    },
    nextNumberSalesOfBusiness: {
      get: function () {
        return this.standardApplication.nextNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberSalesOfBusiness = 0;
        } else {

          this.standardApplication.nextNumberSalesOfBusiness = val;
        }
      },
    },
    nextNumberMortgageBrokering: {
      get: function () {
        return this.standardApplication.nextNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberMortgageBrokering = 0;
        } else {

          this.standardApplication.nextNumberMortgageBrokering = val;
        }
      },
    },
    nextNumberRealEstateConsulting: {
      get: function () {
        return this.standardApplication.nextNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberRealEstateConsulting = 0;
        } else {

          this.standardApplication.nextNumberRealEstateConsulting = val;
        }
      },
    },
    nextNumberOther: {
      get: function () {
        return this.standardApplication.nextNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberOther = 0;
        } else {

          this.standardApplication.nextNumberOther = val;
        }
      },
    },
    //
    // totalLastRevenue() {
    //   return (
    //     Number(this.totalLastRevenueResidentialAppraisal) +
    //     Number(this.totalLastRevenueCommercialAppraisal) +
    //     Number(this.totalLastRevenueRealEstateSales) +
    //     Number(this.totalLastRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalLastNumber() {
    //   return (
    //     Number(this.totalLastNumberResidentialAppraisal) +
    //     Number(this.totalLastNumberCommercialAppraisal) +
    //     Number(this.totalLastNumberRealEstateSales) +
    //     Number(this.totalLastNumberOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextRevenue() {
    //   return (
    //     Number(this.totalNextRevenueResidentialAppraisal) +
    //     Number(this.totalNextRevenueCommercialAppraisal) +
    //     Number(this.totalNextRevenueRealEstateSales) +
    //     Number(this.totalNextRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextNumber() {
    //   return (
    //     Number(this.totalNextNumberResidentialAppraisal) +
    //     Number(this.totalNextNumberCommercialAppraisal) +
    //     Number(this.totalNextNumberRealEstateSales) +
    //     Number(this.totalNextNumberOtherServices)
    //   ).toFixed(0);
    // }
    lastRevenueAuctioneering: {
      get: function () {
        return this.standardApplication.lastRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueAuctioneering = 0;
        } else {

          this.standardApplication.lastRevenueAuctioneering = val;
        }
      },
    },
    lastNumberAuctioneering: {
      get: function () {
        return this.standardApplication.lastNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberAuctioneering = 0;
        } else {

          this.standardApplication.lastNumberAuctioneering = val;
        }
      },
    },
    nextRevenueAuctioneering: {
      get: function () {
        return this.standardApplication.nextRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueAuctioneering = 0;
        } else {

          this.standardApplication.nextRevenueAuctioneering = val;
        }
      },
    },
    nextNumberAuctioneering: {
      get: function () {
        return this.standardApplication.nextNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberAuctioneering = 0;
        } else {

          this.standardApplication.nextNumberAuctioneering = val;
        }
      },
    },


    lastRevenueShortTermEscrow: {
      get: function () {
        return this.standardApplication.lastRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastRevenueShortTermEscrow = 0;
        } else {

          this.standardApplication.lastRevenueShortTermEscrow = val;
        }
      },
    },
    lastNumberShortTermEscrow: {
      get: function () {
        return this.standardApplication.lastNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.lastNumberShortTermEscrow = 0;
        } else {

          this.standardApplication.lastNumberShortTermEscrow = val;
        }
      },
    },
    nextRevenueShortTermEscrow: {
      get: function () {
        return this.standardApplication.nextRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextRevenueShortTermEscrow = 0;
        } else {

          this.standardApplication.nextRevenueShortTermEscrow = val;
        }
      },
    },
    nextNumberShortTermEscrow: {
      get: function () {
        return this.standardApplication.nextNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.standardApplication.nextNumberShortTermEscrow = 0;
        } else {

          this.standardApplication.nextNumberShortTermEscrow = val;
        }
      },
    },

  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "standard-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.standardApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
          this.state.pageTwoIsValid = false;
          this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {}
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
